import React, { Fragment } from 'react';
import '../DriverPolicy/driverPolicy.css';
import './driverFaq.css';
import lockLoc from '../../../images/driverFAQ/lockLoc.png';
import payment from '../../../images/payment-methods.png';
import findcar1 from '../../../images/findcar1.png';
import findcar2 from '../../../images/findcar2.png';
import startbooking from '../../../images/start.png';
import lockunlock1 from '../../../images/lockunlock1.png';
import lockunlock2 from '../../../images/lockunlock2.png';
import extendbooking2 from '../../../images/extend2.png';
import extendbooking3 from '../../../images/extend3.png';
import return1 from '../../../images/return.png';
import opendoor1 from '../../../images/opendoor1.jpeg';
import opendoor2 from '../../../images/opendoor2.png';
import changegear from '../../../images/change-gear.png';
import mirrorwheel1 from '../../../images/mirrorwheel1.png';
import mirrorwheel2 from '../../../images/mirrorwheel2.png';
import opentrunk from '../../../images/opentrunk.png';
import lowbattery from '../../../images/lowbattery.png';
import locationmark from '../../../images/locationmark.png';
import chargermark from '../../../images/chargermark.png';

const Autzu = () => (
  <Fragment>
    <div>
      <iframe
        className="video-frame"
        src="https://www.youtube.com/embed/grMxYe8wM-I?si=L5so9GEforku05ta"
        allow="autoplay; encrypted-media; fullscreen"
        allowFullScreen
        webkitAllowFullScreen
        mozAllowFullScreen
        title="video"
      />
    </div>
    <br />
    <p>
      Autzu is a drivesharing platform offering versatile hourly and daily
      electric vehicle rentals for ride-sharing or food delivery services.
      Our fleet of well-maintained, clean vehicles are always prepared for
      your needs. Hourly rental fees start from $7/hour.
    </p>
  </Fragment>
);

const Drivesharing = () => (
  <Fragment>
    <p>
      Drivesharing allows multiple drivers to share the use of rideshare
      vehicles to transport passengers or deliveries. Drivesharing reduces
      overall traffic congestion and carbon emissions as the total number
      of vehicles on the road is reduced; Autzu accomplishes this by
      providing environmentally-sustainable solutions, such as electric
      vehicles.
    </p>
  </Fragment>
);

const Ridesharing = () => (
  <Fragment>
    <p>
      Ridesharing is any technology platform that connects driver partners
      with riders or delivery requests. As a driver, you will be able to
      use Autzu vehicles to pick up and transport passengers and
      deliveries, and will be paid a fare by the rideshare company for each
      completed trip.
    </p>
  </Fragment>
);

const VehicleType = () => (
  <Fragment>
    <p>
      We offer the sleek and high-performing Tesla Model 3 in both Long
      Range (568 km) and Short Range (423 km) options. Our vehicles are
      automatically assigned for you based on fleet availability.
    </p>
  </Fragment>
);

const VehicleTypeSF = () => (
  <Fragment>
    <p>
      We offer the sleek and high-performing Tesla Model 3 in both Long
      Range (333 mi) and Standard Range (272 mi) options. Our vehicles are
      automatically assigned for you based on fleet availability.
    </p>
  </Fragment>
);

const SpecificVehicle = () => (
  <Fragment>
    <p>
      No. You cannot choose a vehicle based on personal preference as
      vehicles are automatically assigned to you by our system based on
      important variables such as availability, cleanliness, and
      maintenance.
    </p>
  </Fragment>
);

const TimeSlot = () => (
  <Fragment>
    <div>
      Yes, you can create bookings up to one year in advance. Booking in
      advance with Autzu offers the following advantages:
    </div>
    <ul>
      <li>
        <strong>Getting Lower Rates: </strong>Autzu recommends booking in
        advance to secure a booking for the lowest price possible.
      </li>
      <li>
        <strong>Securing a Vehicle: </strong>By booking in advance, you can
        ensure that a vehicle is available for the specific times you want
        to drive. This is particularly useful during peak times or busy
        days when demand for vehicles may be high.
      </li>
    </ul>
  </Fragment>
);

const PaymentWork = () => (
  <Fragment>
    <ol>
      <li>
        <strong>Rental Fee Charge: </strong>The rental fee for your booking
        will be charged to your payment method two hours prior to your
        booking begins.
      </li>
      <li>
        <strong>Extension & Supercharging Charges: </strong>If you decide
        to extend your booking or if you complete a Supercharging session,
        charges will be applied immediately after each respective action.
      </li>
      <li>
        <strong>Additional Fees: </strong>Any other fees (i.e. late fees or
        low-charge fees) that may arise during your rental period will be
        charged at the end of your booking.
      </li>
      <li>
        <strong>Accepted Payment Methods: </strong>Autzu accepts all major
        credit and virtual debit cards.
      </li>
    </ol>
  </Fragment>
);

const PersonalUse = () => (
  <Fragment>
    <p>
      Our vehicles are only for use with ridesharing and are closely
      monitored. In the unlikely event of an accident, the insurance
      deductible is $2,500. If you opt-in to our reduced deductible plan,
      the insurance deductible will be at a discounted price of $1,000.
    </p>
  </Fragment>
);

const OthersDrive = () => (
  <Fragment>
    <p>
      You will be fully liable for any damages or incidents that occur if
      you let an unauthorized person drive the vehicle. It's essential to
      ensure that only authorized users operate the vehicle to prevent any
      potential issues or liabilities.
    </p>
  </Fragment>
);

const PTCLicense = () => (
  <Fragment>
    <p>
      A PTC (Private Transportation Company) license refers to a license
      granted to drivers associated with ride-sharing companies. It's a
      regulatory measure introduced in certain regions to ensure that
      rideshare drivers meet specific safety and operational standards.
    </p>
    <p>
      You would require a PTC license to drive with Autzu if you're
      planning to receive passenger trips in areas like Toronto,
      Mississauga, Scarborough, and Oakville within Ontario, a PTC license
      is mandatory.
    </p>

    <p>
      To get your PTC license, you must complete the{' '}
      <a
        className="faq__panel--link"
        href="https://www.uber.com/ca/en/drive/requirements/training/?cityID=toronto">
        <b>mandatory Toronto Driver Training program</b>
      </a>{' '}
      at one of the accredited schools.
    </p>
  </Fragment>
);

const OtherLicense = () => (
  <Fragment>
    <p>
      To drive with Autzu in Toronto, you must have an Ontario driver’s
      license (Class G or above). We recommend that you exchange your
      out-of-province or international license before registering for an
      account with us.
    </p>

    <p>
      In Ontario, you can obtain your Ontario driver’s license 60 days
      after you’ve moved to the province. For more information on how you
      can switch your license from another province, visit{' '}
      <a
        className="faq__panel--link"
        href="https://www.ontario.ca/page/exchange-out-province-drivers-licence">
        <b>Service Ontario.</b>
      </a>
    </p>
  </Fragment>
);

const OtherLicenseSF = () => (
  <Fragment>
    <p>
      To drive with Autzu, you must have a license registered with the
      state where Autzu operates. We recommend that you exchange your
      out-of-state or international license before registering for an
      account with us.
    </p>

    <p>
      For more information on how you can switch your license from another
      state, visit the{' '}
      <a
        className="faq__panel--link"
        href="https://www.dmv.ca.gov/portal/field-office/san-francisco/"
        target="_blank">
        <b>DMV website </b>
      </a>
      .
    </p>
  </Fragment>
);

const UpfrontFee = () => (
  <Fragment>
    <p>
      No, there are no upfront fees or deposits when signing up or creating
      a booking with Autzu. Charges are only applied two hours before the
      commencement of your booking appointment.
    </p>
  </Fragment>
);

const Approval = () => (
  <Fragment>
    <p>
      If you already have an active rideshare driver account, you can begin
      driving with Autzu immediately.
    </p>
    <p>
      If you do not already have a rideshare driver account, you will need
      to sign up with the rideshare company and complete your background
      check. We recommend completing the{' '}
      <a
        className="faq__panel--link"
        href="https://www.ontario.ca/page/exchange-out-province-drivers-licence">
        <b>mandatory Toronto Driver Training</b>
      </a>{' '}
      program to get your PTC license to maximize earning potential. This
      process can take approximately 7 days.
    </p>
  </Fragment>
);

const ApprovalOTT = () => (
  <Fragment>
    <p>
      It typically takes a few hours for your information to be imported
      into Autzu’s vehicle system. You may start booking as soon as your
      rideshare driver account is successfully connected and your Autzu
      account becomes active.
    </p>
  </Fragment>
);

const ApprovalSF = () => (
  <Fragment>
    <p>
      If you already have an active rideshare driver account, you can begin
      driving with Autzu immediately.
    </p>
    <p>
      If you do not already have a rideshare driver account, you must sign
      up with the rideshare company and complete your background check.
      Once your rideshare driver account is active, you can begin driving
      with Autzu.
    </p>
  </Fragment>
);

const RideshareAccount = () => (
  <Fragment>
    <p>
      If you do not have a rideshare driver account, you can create one
      within the Autzu app. Simply follow the steps on your Dashboard.
    </p>
    <ol>
      <li>
        <strong>Create an Uber Driver account: </strong>Download and open
        the Uber Driver app on your mobile device.
      </li>
      <li>
        <strong>Upload Personal Documents: </strong>Upload your Ontario
        driver’s license (Class G or above), proof of work eligibility
        (like a passport), and a clear profile picture.
      </li>
      <li>
        <strong>Background Check: </strong>Once all documents are submitted
        and approved, you will receive an email to complete your background
        check.
      </li>
      <li>
        <strong>Activate Account: </strong>Your Uber Driver account will
        now be active and you can begin driving!
      </li>
    </ol>
  </Fragment>
);

const RideshareAccountSF = () => (
  <Fragment>
    <p>
      If you do not have a rideshare driver account, you can create one
      within the Autzu app. Simply follow the steps on your Dashboard.
    </p>
    <ol>
      <li>
        <strong>Create an Uber Driver account: </strong>
        Download and open the Uber Driver app on your mobile device.
      </li>
      <li>
        <strong>Upload Personal Documents: </strong>
        Upload your driver’s license (full permit, must be valid in the
        state you intend to operate in), proof of work eligibility (e.g.
        passport), and a clear profile picture.
      </li>
      <li>
        <strong>Background Check: </strong>
        Once all documents are submitted and approved, you will receive an
        email to complete your background check.
      </li>
      <li>
        <strong>Activate Account: </strong>
        Your Uber Driver account will now be active and you can begin
        driving!
      </li>
    </ol>
  </Fragment>
);

const ConnectRideshareAcc = () => (
  <Fragment>
    <p>
      Connecting your rideshare driver account to Autzu is necessary for
      the following reasons:
    </p>
    <ul>
      <li>
        <strong>Vehicle Assignment: </strong>By connecting your rideshare
        driver account, Autzu can assign you to one of their vehicles and
        communicate this information to the rideshare company. This ensures
        that you can use Autzu's vehicles for your rideshare driving.
      </li>
      <li>
        <strong>Compliance: </strong>Rideshare companies need to know the
        details of the vehicle you're driving, including the make, model,
        license plate, and insurance information. Connecting your account
        allows Autzu to share this information with the rideshare company
        on your behalf.
      </li>
    </ul>
    <p>
      It's important to note that Autzu does not modify your profile,
      collect your rideshare earnings, or interfere with your rideshare
      driver account. The connection is purely for vehicle assignment and
      compliance purposes.
    </p>
  </Fragment>
);

const ConnectRideshareAccSF = () => (
  <Fragment>
    <p>
      Connecting your rideshare driver account to Autzu is necessary for
      the following reasons:
    </p>
    <ul>
      <li>
        <strong>Vehicle Assignment: </strong>By connecting your rideshare
        driver account, Autzu can assign you to one of their vehicles and
        communicate this information to the rideshare company. This ensures
        that you can use Autzu's vehicles for your rideshare driving.
      </li>
      <li>
        <strong>Compliance: </strong>Rideshare companies need to know the
        details of the vehicle you're driving, including the make, model,
        license plate, and insurance information. Connecting your account
        allows Autzu to share this information with the rideshare company
        on your behalf.
      </li>
    </ul>
    <p>
      It's important to note that Autzu does not modify your profile,
      collect your rideshare earnings, or interfere with your rideshare
      driver account. The connection is purely for vehicle assignment and
      compliance purposes.
    </p>
  </Fragment>
);

const WithoutAccount = () => (
  <Fragment>
    <p>
      No, unfortunately not. We require you to be connected to our system
      to send over information to the rideshare company about the assigned
      car, allowing you to go online. If you disconnect your rideshare
      driver account, your Autzu account will be temporarily suspended
      until it is reconnected.
    </p>
  </Fragment>
);

const ReserveCar = () => (
  <Fragment>
    <p>
      When you first open the mobile app, you will see the{' '}
      <strong>Book</strong> button on the top right of the screen.
    </p>

    <p>
      Book in advance with no upfront charge - your payment card on file
      will only be charged at the end of your booking. You can book as far
      in advance as you’d like, so you may plan your schedule accordingly.
    </p>
  </Fragment>
);

const RentalFees = () => (
  <Fragment>
    <p>
      Add your credit or debit card details to your Autzu account in{' '}
      <strong>Payment Methods</strong>. Your card on file will only be
      charged at the end of your booking.
    </p>

    <p>
      Any last minute cancellations, late fees, gas shortages, or damage
      related charges will be charged to your card on file.
    </p>
  </Fragment>
);

const Cancellation = () => (
  <Fragment>
    <p>
      Our flexible cancellation policy allows you to cancel your bookings
      without any fees as long as you do so{' '}
      <strong>24 hours before</strong> your start time.You can cancel your
      booking directly through the Autzu app by heading over to your
      Dashboard.
    </p>

    <p>Our full cancellation policy is below:</p>
    <div className="faq__column--container">
      <table className="faq__table">
        <thead>
          <th className="faq__table__th" style={{ fontWeight: 'bold' }}>
            Cancellation Time
          </th>
          <th className="faq__table__th" style={{ fontWeight: 'bold' }}>
            Cancellation Fees
          </th>
        </thead>
        <tbody>
          <tr>
            <td className="faq__table__td">
              More than 24 hours from the booking start time
            </td>
            <td className="faq__table__td">No charge</td>
          </tr>
          <tr>
            <td className="faq__table__td">
              24 hours to 2 hours from the booking start time
            </td>
            <td className="faq__table__td">50% of total booking fees</td>
          </tr>
          <tr>
            <td className="faq__table__td">
              Within 2 hours from the booking start time
            </td>
            <td className="faq__table__td">100% of total booking fees</td>
          </tr>
        </tbody>
      </table>
    </div>
    <br />
    <p>
      Cancellation fees are structured this way to ensure Autzu can
      adequately dedicate vehicles to drivers based on their bookings. We
      do not overbook time slots, so last-minute cancellations result in a
      low probability of this vehicle being re-booked by another driver.
    </p>
  </Fragment>
);

const FindCar = () => (
  <Fragment>
    <p>
      Once you arrive at the hub at ground level, select “I’m at the hub”
      on your dashboard. You will be assigned a vehicle and its license
      plate number will be displayed accordingly. The parking spot for the
      vehicle will be visible after you confirm your personal vehicle
      information during the “Locate and inspect” stage.
    </p>
    <br />
    <div style={{ textAlign: 'center' }}>
      <img src={findcar1} style={{ width: '200px', height: '455px' }} />
      <img src={findcar2} style={{ width: '200px', height: '455px' }} />
    </div>
  </Fragment>
);

const UnlockCar = () => (
  <Fragment>
    <p>
      To begin your booking, you must allow all notifications and have your
      GPS and location services enabled. Go into your phone settings to
      update the permissions to always allow Autzu to access.
    </p>
    <p>
      When you arrive at the parking hub, you will be able to select “I’m
      at the hub” where you will then be prompted to complete your
      pre-booking inspection before starting your appointment. Once
      complete, you will be able to enter the vehicle and begin your drive.
    </p>
    <br />
    <div style={{ textAlign: 'center', width: '100%' }}>
      <img
        src={startbooking}
        style={{ width: '200px', height: '455px' }}
      />
    </div>
  </Fragment>
);

const ExtendBooking = () => (
  <Fragment>
    <p>
      Yes, you can extend your reservation in 2-hour increments or by the
      day for up to 7 consecutive days, provided you do so at least 30
      minutes before your scheduled end time.
    </p>
    <br />
    <p>
      It is important to extend your booking as early as possible,
      otherwise, your vehicle may be assigned to the next driver.
    </p>
    <ol>
      <li>
        On your dashboard, tap the “Extend booking” icon on your current
        booking.
      </li>
      <li>
        Choose how many day(s) and/or hour(s) that you would like to extend
        to and press next to confirm.
      </li>
    </ol>
    <br />
    <br />
    <div style={{ textAlign: 'center', width: '100%' }}>
      <img src={lockunlock1} style={{ width: '200px', height: '455px' }} />
      <img
        src={extendbooking2}
        style={{ width: '200px', height: '455px' }}
      />
      <img
        src={extendbooking3}
        style={{ width: '200px', height: '455px' }}
      />
    </div>
  </Fragment>
);

const EndBooking = () => (
  <Fragment>
    <p>
      Check out our tutorial{' '}
      <a
        className="faq__panel--link"
        target="_blank"
        href="https://www.youtube.com/watch?v=rm8M6Lyp-4Q&list=PLypJbLBqp9zicsWFtZd4ILySpShdpxOXu&index=6">
        <b> here</b>
      </a>{' '}
      on how to end your booking.
    </p>
    <ol>
      <li>
        <strong>
          Return the vehicle to the same hub location where you picked up
          the vehicle.
        </strong>
        <div>
          Make sure the vehicle is returned with a sufficient battery
          charge and that the charger (where applicable) is plugged in
          correctly. To confirm the Autzu hub address, go to the Dashboard
          and select Hub Location.
        </div>
      </li>
      <br />
      <li>
        <strong>
          Park the vehicle in Autzu’s designated parking space.
        </strong>
        <div>
          You can park the vehicle anywhere in Autzu’s designated parking
          spots. Confirm in the app the parking spot that you have returned
          the vehicle to for the next driver.
        </div>
      </li>
      <br />
      <li>
        <strong>Remove your personal items.</strong>
        <div>
          Make sure to remove all of your personal items and any litter
          from inside the vehicle. If you have found a lost item from a
          rider, please report it to the rideshare company.
        </div>
      </li>
      <br />
      <li>
        <strong>Lock the vehicle.</strong>
        <div>
          To lock the vehicle, go to the Dashboard and swipe right to Lock.
        </div>
      </li>
      <br />
      <li>
        <strong>End Booking.</strong>
        <div>
          Select the End booking icon, at the top on your Dashboard, which
          will always be accessible during a booking.
        </div>
      </li>
    </ol>
  </Fragment>
);

const FeeTable = () => (
  <Fragment>
    <div className="faq__column--container">
      See below for a table of the most common fees
      <table className="faq__table">
        <thead>
          <th className="faq__table__th" style={{ fontWeight: 'bold' }}>
            Description
          </th>
          <th className="faq__table__th" style={{ fontWeight: 'bold' }}>
            Fee
          </th>
        </thead>
        <tbody>
          <tr>
            <td className="faq__table__td">Draining EV battery to 0%</td>
            <td className="faq__table__td">
              $250 + any car towing/recovery fees
            </td>
          </tr>
          <tr>
            <td className="faq__table__td">
              Battery charge level under the 70% threshold
            </td>
            <td className="faq__table__td">$0.90 for every 1%</td>
          </tr>
          <tr>
            <td className="faq__table__td">
              Failure to plug in EV charger (if available) at parking hub
            </td>
            <td className="faq__table__td">$20</td>
          </tr>
          <tr>
            <td className="faq__table__td">Returning vehicle late</td>
            <td className="faq__table__td">$0.45/minute</td>
          </tr>
          <tr>
            <td className="faq__table__td">
              Damage to vehicle (when deemed at-fault)
            </td>
            <td className="faq__table__td">Up to $2,500</td>
          </tr>
          <tr>
            <td className="faq__table__td">Damage to decals/stickers</td>
            <td className="faq__table__td">$100</td>
          </tr>
          <tr>
            <td className="faq__table__td">Smoking cleaning fee</td>
            <td className="faq__table__td">$200</td>
          </tr>
          <tr>
            <td className="faq__table__td">Vehicle cleaning fee</td>
            <td className="faq__table__td">$150</td>
          </tr>
          <tr>
            <td className="faq__table__td">
              Tire replacement (side puncture)
            </td>
            <td className="faq__table__td">$250</td>
          </tr>
        </tbody>
      </table>
    </div>
  </Fragment>
);

const FeeTableSF = () => (
  <Fragment>
    <div className="faq__column--container">
      See below for a table of the most common fees
      <table className="faq__table">
        <thead>
          <th className="faq__table__th" style={{ fontWeight: 'bold' }}>
            Description
          </th>
          <th className="faq__table__th" style={{ fontWeight: 'bold' }}>
            Fee (tax included)
          </th>
        </thead>
        <tbody>
          <tr>
            <td className="faq__table__td">Draining EV battery to 0%</td>
            <td className="faq__table__td">
              $271.57 + any car towing/recovery fees (up to $543.13)
            </td>
          </tr>
          <tr>
            <td className="faq__table__td">
              Battery charge level under the 70% threshold
            </td>
            <td className="faq__table__td">$1.51 for every 1%</td>
          </tr>
          <tr>
            <td className="faq__table__td">
              Failure to plug in EV charger (if available) at parking hub
            </td>
            <td className="faq__table__td">$21.73</td>
          </tr>
          <tr>
            <td className="faq__table__td">Returning vehicle late</td>
            <td className="faq__table__td">$0.49/minute</td>
          </tr>
          <tr>
            <td className="faq__table__td">
              Damage to vehicle (when deemed at-fault)
            </td>
            <td className="faq__table__td">Up to $2,715.63</td>
          </tr>
          <tr>
            <td className="faq__table__td">Damage to decals/stickers</td>
            <td className="faq__table__td">$108.63</td>
          </tr>
          <tr>
            <td className="faq__table__td">Smoking cleaning fee</td>
            <td className="faq__table__td">$217.25</td>
          </tr>
          <tr>
            <td className="faq__table__td">Vehicle cleaning fee</td>
            <td className="faq__table__td">$162.94</td>
          </tr>
          <tr>
            <td className="faq__table__td">
              Tire replacement (side puncture) + Labor
            </td>
            <td className="faq__table__td">$260.70 + $32.59</td>
          </tr>
        </tbody>
      </table>
    </div>
  </Fragment>
);

const EmergencyFlatTire = () => (
  <Fragment>
    <p>Please follow the steps below:</p>
    <ol>
      <li>
        If you are unable to drive the vehicle back to the hub, contact
        Autzu 24/7 live chat support within the Autzu app by selecting
        Support on the navigation bar > New support ticket and ask for
        roadside assistance.{' '}
      </li>
      <li>
        Ask the Autzu representative for the name of the towing company
        being sent.{' '}
        <strong>
          Do not give the vehicle to any other towing company than the one
          stated by the Autzu representative.
        </strong>
      </li>
      <li>
        Stay with the vehicle until the authorized tow truck arrives at
        your location and the vehicle will be taken to one of our approved
        repair vendors.
      </li>
      <li>
        Let the towing operator know that a key is not needed and that they
        can take the vehicle.
      </li>
      <li>
        Once the vehicle has been towed, call Autzu to discuss transport
        arrangements to get back to the hub (if you need to pick up your
        personal vehicle).
      </li>
      <li>
        You will be reimbursed for unused time if your booking ended
        earlier than scheduled.
      </li>
    </ol>
    <p>
      We will contact you within 1-2 days to confirm if you will be liable
      for the tire or rim repair cost (depending on the specific issue).
    </p>
  </Fragment>
);

const EarnSteps = () => (
  <Fragment>
    <ol>
      <li>Make a booking in the Autzu app</li>
      <li>
        Before your booking starts, you will be assigned an Autzu vehicle
      </li>
      <li>
        Open the Uber Driver app, go online with the assigned vehicle, and
        receive trips (also see:{' '}
        <a
          href="#panel1title3"
          style={{ textDecoration: 'none', color: '#414141' }}>
          <b>How do I use the Uber Driver app with Autzu cars?</b>
        </a>
        )
      </li>
      <li>
        You will be paid your total earnings from Uber directly. Please
        make sure to check that you have set up your payout method with
        Uber.
      </li>
    </ol>
    <br />
    <p>
      Stay tuned for more information on driving Lyft in the near future.
    </p>
  </Fragment>
);

const FindKey = () => (
  <Fragment>
    <p>
      There is a lock box secured to the wall under the Autzu reserved
      parking sign of the parking spot. You will find the specific parking
      spot number and lock box code for your Autzu vehicle in the
      <a
        className="faq__panel--link"
        href="http://www.autzu.com/dashboard">
        <b> Dashboard</b>
      </a>
      .
    </p>

    <div style={{ width: '100%', textAlign: 'center' }}>
      <img src={lockLoc} style={{ width: '219px', height: '290px' }} />
    </div>
  </Fragment>
);

const OpenCloseLock = () => (
  <Fragment>
    <p>
      When you confirm that you are at the hub and have inputted your
      personal vehicle details, you will see the option to slide to unlock
      the vehicle after your pre-booking inspection. When the pre-booking
      inspection is complete, you can control the vehicle assigned to your
      booking.
    </p>
    <br />
    <p>To lock/unlock your vehicle:</p>
    <ol>
      <li>
        Lock the vehicle by selecting the lock icon. If successful, the
        lock icon will display “Success”. If it fails, you will see an “X”
        appear and will need to try again.
      </li>
      <li>
        To unlock the vehicle, select the unlock icon. If successful, the
        unlock icon will display “Success”. If it fails, you will see an
        “X” appear and will need to try again.
      </li>
    </ol>
    <br />

    <div style={{ textAlign: 'center', width: '100%' }}>
      <img src={lockunlock1} style={{ width: '200px', height: '455px' }} />
      <img src={lockunlock2} style={{ width: '200px', height: '455px' }} />
    </div>
    <br />
    <p>
      This process may take up to 30 seconds and requires you to have a
      good cellular connection to be successful.
    </p>
  </Fragment>
);

const OpenDoor = () => (
  <Fragment>
    {' '}
    <p>
      To open the door, push in on the far right side of the handle, with
      your thumb and pull the handle. To get out, press the button located
      at the top of the handle inside the vehicle.
    </p>
    <br />
    <div style={{ textAlign: 'center' }}>
      <img src={opendoor1} style={{ width: '200px', height: '200px' }} />
      <img src={opendoor2} className="openDoor-image" />
    </div>
  </Fragment>
);

const FillUpGas = () => (
  <Fragment>
    <p>
      Yes. It is your responsibility to make sure that the gas tank is full
      upon return of the vehicle for all Autzu PRO vehicles.
    </p>
    <br />
    <p>
      If you reported a gas shortage at the start of your booking, you must
      still refill the gas to 100% full, as we will provide you with a
      credit to cover the cost of gas, plus inconvenience. See{' '}
      <a href="#autzu-pro-gas-policy">Gas Policy</a> for more details.
    </p>
  </Fragment>
);

const Recharge = () => (
  <Fragment>
    <p>
      Yes. It is your responsibility to make sure that the charger is
      plugged in and charging (blinking green light) when you return and
      park the Autzu EV vehicle.
    </p>
    <br />
    <p>
      If you reported that the battery level was low at the start of your
      booking, you must head out to the nearest Tesla Supercharger during
      your booking to charge the vehicle for 20-60 minutes.
    </p>
    <br />
    <p>
      If you fail to properly charge the electric vehicle, you will be
      charged additional fees. See{' '}
      <a href="#drivesharing-policies">EV Charging Policy</a> for more
      details.
    </p>
  </Fragment>
);

const ReturnVehicle = () => (
  <Fragment>
    <p>
      Upon returning to the hub, you can park the vehicle in any specified
      Autzu parking spot (look for signage). You will need to verify this
      by selecting the parking spot in the app, uploading a picture as
      proof.
    </p>
    <br />
    <div style={{ textAlign: 'center', width: '100%' }}>
      <img src={return1} style={{ width: '200px', height: '455px' }} />
    </div>
  </Fragment>
);

const Discounts = () => (
  <Fragment>
    <div>Drive with Autzu and earn up to $100 in credits every week! </div>
    <ul>
      <li>Book 50 hours or more, and you'll receive a $50 credit</li>
      <li>Book 80 hours or more, and you'll receive a $100 credit</li>
    </ul>
    <br />
  </Fragment>
);

const ReferralBonus = () => (
  <Fragment>
    <div>
      You and a friend can both earn $150 each. Share your referral link
      found in the Promotions section of the Autzu app.
    </div>
    <ul>
      <li>
        Once your friend completes 20 hours of driving, you'll both receive
        $50
      </li>
      <li>
        When your friend completes 100 hours of driving, you’ll both
        receive another $100
      </li>
    </ul>
  </Fragment>
);

const StartElectric = () => (
  <Fragment>
    <p>
      Head to your dashboard and select “Start motor” to start the motor of
      the vehicle assigned to you.
    </p>
    <br />
    <p>
      <strong>
        If you leave the seat anytime during your booking, the car will be
        disabled and you will need to press the “Start Motor” button again
        to select a gear and continue driving.
      </strong>
    </p>
    <br />
    <div style={{ textAlign: 'center' }}>
      <img src={lockunlock1} style={{ width: '200px', height: '455px' }} />
      <img src={lockunlock2} style={{ width: '200px', height: '455px' }} />
    </div>
  </Fragment>
);

const ChangeGears = () => (
  <Fragment>
    <p>
      To switch gears, hold the brake pedal down with your foot and shift
      the gear lever located on the right side behind the steering wheel.
    </p>
    <br />
    <p>
      Push down for Drive, push up for Reverse. Press the button at the end
      of the gear lever for Park.
    </p>
    <br />
    <div style={{ textAlign: 'center' }}>
      <img className="changeGear-image" src={changegear} />
    </div>
  </Fragment>
);

const AdjustWheel = () => (
  <Fragment>
    <p>
      You can access the option to adjust your mirrors or steering wheel
      using the central display or voice command. Changing the rearview
      mirror is done manually like most vehicles.{' '}
      <strong>
        Click{' '}
        <a
          className="faq__panel--link"
          href="https://youtu.be/9OZtdixfWug">
          here
        </a>{' '}
        to view the video tutorial
      </strong>
      .
    </p>
    <br />
    <ol>
      <li>
        <strong>Central display: </strong>
        select Controls (vehicle icon) {'>'} Quick Controls {'> '}
        choose Mirrors or Steering Wheel and then use the control on the
        left side of the steering wheel to make your adjustments.
      </li>
    </ol>
    <br />
    <div style={{ textAlign: 'center', flexDirection: 'column' }}>
      <img src={mirrorwheel1} className="mirrorWheel-image" />
      <img src={mirrorwheel2} className="mirrorWheel-image" />
    </div>
  </Fragment>
);

const OpenTrunk = () => (
  <Fragment>
    <p>
      You can open the front trunk, back trunk or charging port by tapping
      on the area that you would like to open from the central display.
    </p>
    <br />
    <div style={{ textAlign: 'center' }}>
      <img className="openTrunk-image" src={opentrunk} />
    </div>
  </Fragment>
);

const HarzardLights = () => (
  <Fragment>
    <div>
      <p>
        The hazard light button is located above you in front of the
        rearview mirror.{' '}
      </p>
    </div>
  </Fragment>
);

const ClimateControl = () => (
  <Fragment>
    <div>
      <p>
        Using the central display, you can adjust your climate by selecting
        one of the icons along the bottom of the screen.
      </p>
      <br />
      <p>
        To adjust your windshield wiper controls, select the windshield
        wiper icon on the central display or you can press the windshield
        wiper button (on the handle) located on your left behind the
        steering wheel.
      </p>
    </div>
  </Fragment>
);

const RegenerativeBraking = () => (
  <Fragment>
    <div>
      <p>
        When you are driving and your foot is taken off of the pedal, the
        vehicle is braking and recapturing the energy that was released so
        that it can be used later on. Most electric vehicles and hybrids
        have regenerative braking which is when the vehicle’s kinetic
        energy converts into chemical energy and is then stored in the
        battery to be used later. This feature cannot be turned off.
      </p>
    </div>
  </Fragment>
);

const LowBatteryLevel = () => (
  <Fragment>
    <p>
      If the battery % is too low to complete your booking, head to the
      nearest Tesla Supercharger or any public third-party charging station
      to charge your vehicle for 20-60 minutes.
    </p>
    <br />
    <div style={{ textAlign: 'center' }}>
      <img src={lowbattery} style={{ width: '200px', height: '455px' }} />
    </div>
  </Fragment>
);

const NearestSupercharger = () => (
  <Fragment>
    <p>
      To find the nearest Tesla Supercharger to you, check the Google Maps
      link{' '}
      <a
        className="faq__panel--link"
        href="https://goo.gl/maps/rdwFC5pdkqFUEUuJA"
        target="_blank">
        <b> here</b>
      </a>
      . Alternatively, you can use the voice command function by holding
      down the two scroll buttons on the steering wheel and saying,
      “Navigate to the nearest supercharger” or, you can use the central
      display and select the electric icon with the circle around it
      located at the bottom right of the screen. You can also use the{' '}
      <a
        className="faq__panel--link"
        href="https://www.plugshare.com/"
        target="_blank">
        <b> Plugshare</b>
      </a>{' '}
      or
      <a
        className="faq__panel--link"
        href="https://www.chargepoint.com/drivers/mobile"
        target="_blank">
        <b> ChargePoint</b>
      </a>{' '}
      apps to locate a charger nearest to you but must make sure that you
      have an adapter for these chargers.
    </p>
    <br />
  </Fragment>
);

const NearestSuperchargerOTT = () => (
  <Fragment>
    <p>
      To find the nearest Tesla Supercharger to you, check the Google Maps
      link{' '}
      <a
        className="faq__panel--link"
        href="https://goo.gl/maps/rdwFC5pdkqFUEUuJA"
        target="_blank">
        <b> here</b>
      </a>
      . Alternatively, you can use the voice command function by holding
      down the two scroll buttons on the steering wheel and saying,
      “Navigate to the nearest supercharger” or, you can use the central
      display and select the electric icon with the circle around it
      located at the bottom right of the screen. You can also use the{' '}
      <a
        className="faq__panel--link"
        href="https://www.plugshare.com/"
        target="_blank">
        <b> Plugshare</b>
      </a>{' '}
      or
      <a
        className="faq__panel--link"
        href="https://www.chargepoint.com/drivers/mobile"
        target="_blank">
        <b> ChargePoint</b>
      </a>{' '}
      apps to locate a charger nearest to you but must make sure that you
      have an adapter for these chargers.
    </p>
    <p>
      The following locations are closest to our Downtown hub at 41 George
      street:
    </p>
    <br />
    <div style={{ flexDirection: 'column' }}>
      <div>
        <img
          src={locationmark}
          style={{
            width: '16px',
            height: '21px',
            position: 'relative',
            bottom: '5px',
            marginRight: '5px'
          }}
        />
        <strong>CF Rideau Centre, Ottawa, ON </strong>
      </div>
      <strong>Open 24/7, Pay to Park</strong>
      <div>50 Rideau St Suite #300 </div>
      <div>Ottawa, ON K1N 9J7</div>
    </div>
    <br />
    <div style={{ flexDirection: 'column' }}>
      <div>
        <img
          src={locationmark}
          style={{
            width: '16px',
            height: '21px',
            position: 'relative',
            bottom: '5px',
            marginRight: '5px'
          }}
        />
        <strong>Canadian Tire, Nepean, ON</strong>
      </div>
      <strong>Open 24/7</strong>
      <div>2135 Robertson Rd</div>
      <div>Nepean, ON K2H 5Z2</div>
    </div>
  </Fragment>
);

const NearestSuperchargerSF = () => (
  <Fragment>
    <p>
      To find the nearest Tesla Supercharger to you, check the Google Maps
      link{' '}
      <a
        className="faq__panel--link"
        href="https://rb.gy/too0f5"
        target="_blank">
        <b> here</b>
      </a>
      . Alternatively, you can use the voice command function by holding
      down the two scroll buttons on the steering wheel and saying,
      “Navigate to the nearest supercharger” or, you can use the central
      display and select the electric icon with the circle around it
      located at the bottom right of the screen. You can also use the{' '}
      <a
        className="faq__panel--link"
        href="https://www.plugshare.com/"
        target="_blank">
        <b> Plugshare</b>
      </a>{' '}
      or
      <a
        className="faq__panel--link"
        href="https://www.chargepoint.com/drivers/mobile"
        target="_blank">
        <b> ChargePoint</b>
      </a>{' '}
      apps to locate a charger nearest to you but must make sure that you
      have an adapter for these chargers.
    </p>
    <br />
    <p>
      The following locations are closest to our Downtown hub at 3
      Embarcadero Center:
    </p>
    <br />
    <div style={{ flexDirection: 'column' }}>
      <div>
        <img
          src={locationmark}
          style={{
            width: '16px',
            height: '21px',
            position: 'relative',
            bottom: '5px',
            marginRight: '5px'
          }}
        />
        <strong>16th Street, San Francisco, CA</strong>
      </div>
      <strong>Potrero Center</strong>
      <div>2300 16th Street</div>
      <div>San Francisco, CA 94103</div>
    </div>
    <br />
    <div style={{ flexDirection: 'column' }}>
      <div>
        <img
          src={locationmark}
          style={{
            width: '16px',
            height: '21px',
            position: 'relative',
            bottom: '5px',
            marginRight: '5px'
          }}
        />
        <strong>Geary Boulevard, San Francisco, CA</strong>
      </div>
      <strong>Open 6AM - 4PM, daily</strong>
      <div>2675 Geary Blvd</div>
      <div>San Francisco, CA 94118</div>
    </div>
    <br />
    <br />
    <div style={{ flexDirection: 'column' }}>
      <div>
        <img
          src={locationmark}
          style={{
            width: '16px',
            height: '21px',
            position: 'relative',
            bottom: '5px',
            marginRight: '5px'
          }}
        />
        <strong>Van Ness Avenue, San Francisco, CA</strong>
      </div>
      <strong>PAY TO PARK, Opera Plaza</strong>
      <div>601 Van Ness Avenue</div>
      <div>San Francisco, CA 94102</div>
    </div>
  </Fragment>
);

const PaySupercharging = () => (
  <Fragment>
    <div>
      <p>
        You must pay for all charging costs associated with your assigned
        electric vehicle. Tesla charging fees will be applied to your Autzu
        account and any third-party or public charging must be paid
        immediately with your preferred payment method.
      </p>
    </div>
  </Fragment>
);

const SuperchargerIdleFee = () => (
  <Fragment>
    <div className="faq__column--container">
      <p>
        Idle fees apply to any car occupying a Supercharger if the station
        is at 50% capacity or more and the charge session is complete (100%
        battery). You have 5 minutes to remove the mobile connector from
        the vehicle and head to your next destination or the following
        fee(s) will apply:
      </p>
      <br />
      <table className="faq__table">
        <thead>
          <th
            className="faq__table__th"
            style={{ fontWeight: 'bold', backgroundColor: '#f2f2f2' }}>
            Description
          </th>
          <th
            className="faq__table__th"
            style={{ fontWeight: 'bold', backgroundColor: '#f2f2f2' }}>
            Currency
          </th>
          <th
            className="faq__table__th"
            style={{ fontWeight: 'bold', backgroundColor: '#f2f2f2' }}>
            Idle fee (per minute)
          </th>
          <th
            className="faq__table__th"
            style={{ fontWeight: 'bold', backgroundColor: '#f2f2f2' }}>
            Idle fee (per minute) when the station is 100% occupied
          </th>
        </thead>
        <tbody>
          <tr>
            <td className="faq__table__td">United States</td>
            <td className="faq__table__td">USD</td>
            <td className="faq__table__td" style={{ textAlign: 'right' }}>
              $0.50
            </td>
            <td className="faq__table__td" style={{ textAlign: 'right' }}>
              $1.00
            </td>
          </tr>
          <tr>
            <td className="faq__table__td">Canada</td>
            <td className="faq__table__td">CAD</td>
            <td className="faq__table__td" style={{ textAlign: 'right' }}>
              $0.50
            </td>
            <td className="faq__table__td" style={{ textAlign: 'right' }}>
              $1.00
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </Fragment>
);

const StartBookingTutorial = () => (
  <div>
    Check out our tutorial{' '}
    <a
      className="faq__panel--link"
      href="https://www.youtube.com/watch?v=qMOQrP-6c-s&list=PLypJbLBqp9zicsWFtZd4ILySpShdpxOXu&index=4"
      target="_blank">
      <b> here</b>
    </a>{' '}
    on how to start your booking.
  </div>
);

const EndBookingTutorial = () => (
  <div>
    Check out our tutorial{' '}
    <a
      className="faq__panel--link"
      href="https://www.youtube.com/watch?v=rm8M6Lyp-4Q&list=PLypJbLBqp9zicsWFtZd4ILySpShdpxOXu&index=6"
      target="_blank">
      <b> here</b>
    </a>{' '}
    on how to end your booking.
  </div>
);

export {
  Autzu,
  Drivesharing,
  Ridesharing,
  VehicleType,
  SpecificVehicle,
  TimeSlot,
  PaymentWork,
  PersonalUse,
  OthersDrive,
  PTCLicense,
  OtherLicense,
  UpfrontFee,
  Approval,
  RideshareAccount,
  ConnectRideshareAcc,
  WithoutAccount,
  ReserveCar,
  RentalFees,
  Cancellation,
  FindCar,
  UnlockCar,
  ExtendBooking,
  EndBooking,
  FeeTable,
  EmergencyFlatTire,
  EarnSteps,
  FindKey,
  OpenCloseLock,
  FillUpGas,
  Recharge,
  ReturnVehicle,
  Discounts,
  ReferralBonus,
  OpenDoor,
  StartElectric,
  ChangeGears,
  AdjustWheel,
  OpenTrunk,
  HarzardLights,
  ClimateControl,
  RegenerativeBraking,
  LowBatteryLevel,
  NearestSupercharger,
  PaySupercharging,
  SuperchargerIdleFee,
  VehicleTypeSF,
  OtherLicenseSF,
  ApprovalSF,
  ConnectRideshareAccSF,
  NearestSuperchargerSF,
  ApprovalOTT,
  NearestSuperchargerOTT,
  RideshareAccountSF,
  FeeTableSF,
  StartBookingTutorial,
  EndBookingTutorial
};



// WEBPACK FOOTER //
// ./src/components/Static/DriverFaq/HelpFunctions.js